import PageHero from '../components/PageHero.jsx';
import { FadeUp } from '../components/Motion.jsx';

const details = [
  {
    term: 'Registered office',
    value: ['biolitec Pharma Ltd.', 'Unit 9A — Plato Business Park, Damastown', 'Dublin 15', 'Ireland'],
  },
  {
    term: 'Branch office',
    value: ['Otto-Schott-Str. 15', '07745 Jena', 'Germany'],
  },
  { term: 'Director and Secretary', value: ['Prof. Volker Albrecht'] },
  { term: 'Directors', value: ['Dr. Winrich H. Rauschning'] },
  { term: 'Registrar of Companies', value: ['Amtsgericht Jena (District Court)'] },
  { term: 'Registration No.', value: ['HRB 510 656'] },
  { term: 'VAT ID', value: ['DE 814 891 802'] },
];

export default function Imprint() {
  return (
    <>
      <PageHero
        eyebrow="LEGAL"
        title="Imprint"
        subtitle="Company and legal information for biolitec Pharma Ltd."
      />

      <div className="page-shell">
        <FadeUp>
          <section className="legal-card">
            <dl className="legal-rows">
              {details.map((d) => (
                <div key={d.term} className="legal-row">
                  <dt>{d.term}</dt>
                  <dd>
                    {d.value.map((line, i) => (
                      <span key={line}>{i > 0 && <br />}{line}</span>
                    ))}
                  </dd>
                </div>
              ))}

              <div className="legal-row">
                <dt>Contact</dt>
                <dd>
                  Phone: <a href="tel:+493641519533 0">+49 3641 519 5330</a><br />
                  Fax: +49 3641 519 5333<br />
                  Email: <a href="mailto:info@biolitecpharma.com">info@biolitecpharma.com</a><br />
                  Internet:{' '}
                  <a href="https://www.biolitecpharma.com" target="_blank" rel="noopener noreferrer">
                    www.biolitecpharma.com
                  </a>
                </dd>
              </div>
            </dl>
          </section>
        </FadeUp>
      </div>
    </>
  );
}